type StoreLike = {
    dispatch: (type: string, payload?: unknown) => Promise<any> | any
    commit: (type: string, payload?: unknown) => void
}

/**
 * Refresh project in store the same way a full page load does (`projects/byId`),
 * so ChannelsTable sees channelId / connector fields. Falls back to fetchProject.
 */
export async function syncProjectAfterChannelChange(
    store: StoreLike,
    projectId: string
): Promise<void> {
    if (!projectId) return
    try {
        await store.dispatch('project/setFastProjectById', projectId)
        return
    } catch (error) {
        console.error('setFastProjectById after channel change failed:', error)
    }
    try {
        await store.dispatch('project/fetchProject', projectId)
    } catch (error) {
        console.error('fetchProject after channel change failed:', error)
    }
}
